// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OtSBlc {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.Vonrvi {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 331px;
}

.APbZ8z {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
  text-align: left;
  width: 100%;
}

.r1ofVD {
  display: flex;
  gap: 12px;
  justify-content: stretch;
  margin-bottom: 16px;
  width: 100%;
}

.MAkyNX {
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  width: 100%;
  gap: var(--spacing-0-5, 4px);
}

.g450k2 {
  height: 12px;
  width: 12px;
  margin-top: 1px;
}

.QKSXoq {
  margin: 0;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  color: var(--text-neutral-stronger, #666666);
  font-size: var(--message-size, 12px);
}

.J8ade5 {
  font-family: 'Source Sans 3', sans-serif;
  font-size: 14px;
  text-align: left;
  color: #1f1f1f;
  margin-bottom: 16px;
}

.Eunm8e {
  background: none;
  border: none;
  color: #1573d3;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
  font-family: 'Source Sans 3', sans-serif;
  padding: 0;
  margin: 0;
}

.Eunm8e:hover {
  opacity: 0.8;
}

.Eunm8e:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.DoBa7W {
  font-weight: 500;
  color: #1f1f1f;
}

.XusXGW {
  text-align: center !important;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/PixKeyConfirmation/PixKeyConfirmation.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iEAAiE;EACjE,4CAA4C;EAC5C,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,wCAAwC;EACxC,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 331px;\n}\n\n.instruction {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n  text-align: left;\n  width: 100%;\n}\n\n.codeInputGroup {\n  display: flex;\n  gap: 12px;\n  justify-content: stretch;\n  margin-bottom: 16px;\n  width: 100%;\n}\n\n.messageContainer {\n  display: flex;\n  align-items: baseline;\n  justify-content: flex-start;\n  width: 100%;\n  gap: var(--spacing-0-5, 4px);\n}\n\n.messageIcon {\n  height: 12px;\n  width: 12px;\n  margin-top: 1px;\n}\n\n.message {\n  margin: 0;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  color: var(--text-neutral-stronger, #666666);\n  font-size: var(--message-size, 12px);\n}\n\n.resendMessage {\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 14px;\n  text-align: left;\n  color: #1f1f1f;\n  margin-bottom: 16px;\n}\n\n.resendLink {\n  background: none;\n  border: none;\n  color: #1573d3;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 14px;\n  font-family: 'Source Sans 3', sans-serif;\n  padding: 0;\n  margin: 0;\n}\n\n.resendLink:hover {\n  opacity: 0.8;\n}\n\n.resendLink:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.countdownText {\n  font-weight: 500;\n  color: #1f1f1f;\n}\n\n.pinInput {\n  text-align: center !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OtSBlc`,
	"content": `Vonrvi`,
	"instruction": `APbZ8z`,
	"codeInputGroup": `r1ofVD`,
	"messageContainer": `MAkyNX`,
	"messageIcon": `g450k2`,
	"message": `QKSXoq`,
	"resendMessage": `J8ade5`,
	"resendLink": `Eunm8e`,
	"countdownText": `DoBa7W`,
	"pinInput": `XusXGW`
};
module.exports = ___CSS_LOADER_EXPORT___;
